import { createStore } from '../../lib/create-store';

import { getActions, getInitialState, getReducer } from '.';

const ACTION_PREFIX = 'LATEST_NEWS';

const initialState = getInitialState();
const reducer = getReducer(ACTION_PREFIX);

export const latestNewsStore = createStore({
  name: 'latestNewsStore',
  initialState,
  reducer,
});

export const latestNewsActions = getActions(ACTION_PREFIX);
